import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks the restoration of a custom field',
  name: 'restore_custom_field',
  params: [
    {
      description: 'The ID of the restored custom field',
      name: 'custom_field_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The name of the restored custom field',
      name: 'custom_field_name',
      required: true,
      type: 'string',
    },
    {
      description: 'The type of the restored custom field',
      name: 'custom_field_type',
      required: true,
      type: 'enum',
      values: ['single-select', 'multi-select', 'plain-text', 'date'],
    },
  ],
};

export default META;
